/**
 * @file The text of a cooldown's whole seconds left: `"45 s"` under a minute,
 * else `"14 min 0 s"`. Consumers: `AnalyticsReportRunActions` and
 * `AnalyticsRecomputeButton`, in their button text and tooltips.
 */
export const analyticsCooldownText = (left: number): string =>
  left < 60 ? `${left} s` : `${Math.floor(left / 60)} min ${left % 60} s`;
